interface ArrowButtonProps {
	direction: 'previous' | 'next';
	disabled?: boolean;
	onClick: () => void;
	title: string;
}

const ArrowButton = ({ direction, disabled = false, onClick, title }: ArrowButtonProps) => {
	const classes = ['stepper__arrow-button', `stepper__arrow-button--${direction}`];
	return <button type="button" disabled={disabled} className={classes.join(' ')} onClick={onClick} title={title} aria-label={title}></button>;
};

interface ValueProps {
	children: React.ReactNode;
	current: boolean;
}

const Value = ({ children, current }: ValueProps) => {
	const classes = ['stepper__value'];
	if (current) classes.push('stepper__value--current');
	return <div className={classes.join(' ')}>{children}</div>;
};

interface StepperProps {
	allowNextStep: boolean;
	allowPreviousStep: boolean;
	children?: React.ReactNode;
	id: string;
	isCurrentValue: boolean;
	stepBackward: () => void;
	stepBackwardTitle: string;
	stepForward: () => void;
	stepForwardTitle: string;
}

export default function Stepper({
	allowNextStep,
	allowPreviousStep,
	children,
	id,
	isCurrentValue,
	stepBackward,
	stepBackwardTitle,
	stepForward,
	stepForwardTitle,
}: StepperProps) {
	return (
		<div id={id} className="stepper">
			<ArrowButton direction="previous" disabled={!allowPreviousStep} title={stepBackwardTitle} onClick={stepBackward} />
			<Value current={isCurrentValue}>{children}</Value>
			<ArrowButton direction="next" disabled={!allowNextStep} title={stepForwardTitle} onClick={stepForward} />
		</div>
	);
}
